export class Anagrafica {
	id!: number;
	nome!: string;
	cognome!: string;
	numiscr!: string;
	sezione!: string;
	settorea!: boolean;
	settoreb!: boolean;
	settorec!: boolean;
	indirizzo!: string;
	tel!: string;
	fax!: string;
	email!: string;
	cellulare!: string;
	indirizzoattivita!: string;
	telattivita!: string;
	titolo!: string;
	laurea!: string;
	datalaurea!: string;
	universitalaurea!: string;
	annoesamestato!: number;
	luogoesamestato!: string;
	dataiscrizione!: string;
	provvedimenti!: string;
	localitanascita!: string;
	datanascita!: string;
	pec!: string;
	cap!: string;
	comune!: string;
	provincia!: string;
	sessioneesamestato!: string;
	dataprimaiscrizione!: string;
	capattivita!: string;
	comuneattivita!: string;
	provinciaattivita!: string;
	sez2!: string;
	numsez2!: string;
	dataiscrsez2!: string;
	settasez2!: boolean;
	settbsez2!: boolean;
	settcsez2!: boolean;
	laureasez2!: string;
	datalaureasez2!: string;
	univlaureasez2!: string;
	annoesamestatosez2!: number;
	luogoesamestatosez2!: string;
	sessioneesamestatosez2!: string;
	codicefiscale!: string;
	indirizzodom!: string;
	capdom!: string;
	comunedom!: string;
	provinciadom!: string;
	teldom!: string;
	emaildom!: string;
	emailsecondaria!: string;
	professione!: string;
	ragionesociale!: string;;
	partitaiva!: string;
	oggettoprofessionale!: string;
	soci?: any[];

}

export class AnagraficaRequest {
	pfx!: string;
	nome!: string;
	cognome!: string;
	numiscr!: string;
	sezione!: string;
	settorea!: boolean;
	settoreb!: boolean;
	settorec!: boolean;
	spec1!: string;
	spec2!: string;
	spec3!: string;
	stp!: boolean;
	ragionesociale!: string;
}

export enum AnagraficaSezione {
	A = 'a',
	B = 'b'
}
